export * from './tr.component';
export * from './tr.directive';
